import React, { useContext, useEffect, useState } from "react";
import {
  Card,
  Form,
  Button,
  Badge,
  Row,
  Col,
  InputGroup,
} from "react-bootstrap";
import { FaArrowRight } from "react-icons/fa";
import { getProfile, SendChatMessage } from "../../services/auth";
import jwtDecode from "jwt-decode";
import { toast } from "react-toastify";
import { toastError, toastSuccess } from "../../config/ToastModal";

import SocketContext from "../../config/SocketContext";

const ChatSupport = () => {
  const [messages, setMessages] = useState();

  const socketContext = useContext(SocketContext);

  const [newMessage, setNewMessage] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("General");
  const [querySelected, setQuerySelected] = useState([]);

  const queryTabs = [
    {
      title: "Account Issues",
      message: "I'm having trouble accessing my account. Can you help?",
    },
    {
      title: "Payment Query",
      message: "I have a question about my recent payment.",
    },
    {
      title: "Technical Support",
      message: "I need technical assistance with the platform.",
    },
    {
      title: "Feature Request",
      message: "I'd like to request a new feature for the system.",
    },
    {
      title: "Billing Question",
      message: "Can you clarify my recent billing statement?",
    },
    {
      title: "Password Reset",
      message: "I need help resetting my password.",
    },
    {
      title: "Report Bug",
      message: "I've encountered a bug that needs attention.",
    },
    {
      title: "General Inquiry",
      message: "I have a general question about the service.",
    },
  ];

  const formatCreatedAt = (dateString) => {
    const createdAt = new Date(dateString);
    const today = new Date();

    today.setHours(0, 0, 0, 0);
    createdAt.setHours(0, 0, 0, 0);

    const diffTime = today - createdAt;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return "Today";
    if (diffDays === 1) return "Yesterday";
    if (diffDays === 2) return "2 days ago";
    if (diffDays === 3) return "3 days ago";

    return createdAt.toISOString().split("T")[0];
  };

  const fetchApplicant = async () => {
    try {
      const data = await getProfile();
      if (data?.data?.chat?.length > 0) {
        setMessages(data?.data?.chat);
      } else {
        setMessages([]);
      }
    } catch (error) {}
  };

  useEffect(() => {
    // const interval = setInterval(() => {
    //   fetchApplicant();
    // }, 2000);
    // return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    fetchApplicant();
  }, []);

  const handleSendMessage = async (messageText = null) => {
    const textToSend = messageText || newMessage;
    if (textToSend.trim() === "") return;
    const token = localStorage.getItem("hr_token");
    if (!token) {
      return;
    }
    const tokenString = token.split("Bearer ")[1];
    const convertId = jwtDecode(tokenString);
    const messageData = {
      userId: convertId?._id,
      message: textToSend,
      type: "company",
    };
    const data = await SendChatMessage(messageData);
    if (data?.data?.status) {
      setNewMessage("");
      setMessages((prevMessages) => [...prevMessages, messageData]);
      fetchApplicant();
    }
  };

  const handleQueryTabClick = async (message) => {
    if (querySelected.includes(message)) {
      toastError("Already sent this message!");
      return;
    } else {
      setQuerySelected((prev) => [...prev, message]);
    }
    const token = localStorage.getItem("hr_token");
    if (!token) {
      return;
    }
    try {
      const tokenString = token.split("Bearer ")[1];
      const convertId = jwtDecode(tokenString);
      const messageData = {
        userId: convertId?._id,
        message: message,
        type: "company",
      };
      const data = await SendChatMessage(messageData);
      if (data?.data?.status) {
        setNewMessage("");
        setMessages((prevMessages) => [...prevMessages, messageData]);
        toastSuccess("Message sent successfully!");
      }
    } catch (error) {}
  };

  useEffect(() => {
    const emitMessage = async (data) => {};

    socketContext?.socket?.on("message", emitMessage);
    return () => socketContext?.socket?.off("message", emitMessage);
  }, []);
  return (
    <div className="row d-flex justify-content-center mt-lg-3 ms-1 ">
      <div className="p-0 ms-lg-5 col-lg-4 mt-lg-2 mb-lg-2 rounded mx-auto bg-white">
        <div
          className="p-3 d-flex justify-content-between rounded align-items-center"
          style={{ background: "#96144d" }}
        >
          <div>
            <h6 className="p-0 m-0 text-white">QUICK QUERIES</h6>
          </div>
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              background: "white",
            }}
          >
            <div className="fw-bold" style={{ color: "#96144d" }}>
              Q
            </div>
          </div>
        </div>

        <div className="p-3 d-flex gap-2" style={{ flexWrap: "wrap" }}>
          {queryTabs.map((tab, index) => (
            <div
              key={index}
              className=" mb-2 rounded cursor qurey-tab"
              style={{
                border: "1px solid grey",
                color: querySelected.includes(tab.message) ? "white" : "grey",
                background: querySelected.includes(tab.message)
                  ? "#96144d"
                  : "white",
                // background: "white",
                transition: "all 0.3s",
                padding: " 5px 10px",
                fontSize: "14px",
              }}
              onClick={() => handleQueryTabClick(tab.message)}
              // onMouseEnter={(e) => (e.target.style.background = "#fff0f7")}
              // onMouseLeave={(e) => (e.target.style.background = "white")}
            >
              <div className="m-0">{tab.title}</div>
            </div>
          ))}
        </div>

        {/* <div className="mt-3 pt-3 border-top">
          <div className="ms-3 mt-3">
            <h6>For More Details</h6>
            <div style={{ color: "grey" }}>Contact: support@cdp360.com</div>
          </div>
        </div> */}
      </div>

      <div className="p-2 pt-0 col-lg-7 mx-auto mt-2 rounded">
        <Card className="" style={{ border: "none" }}>
          <Card.Header
            style={{ color: "white", background: "#97144d" }}
            className="d-flex justify-content-between align-items-center"
          >
            <div className="d-flex align-items-center">
              <Card.Title
                className="mt-3 fw-bold d-flex gap-2"
                style={{ fontSize: "16px" }}
              >
                <span style={{ color: "white" }}>
                  <i className="fa-solid fa-phone-volume"></i>
                </span>
                Admin Support Chat
              </Card.Title>
            </div>
            <div className="d-flex gap-2 align-items-center cursor">
              <span
                className="bg-success rounded-circle"
                style={{ width: "12px", height: "12px" }}
              ></span>
              <span>Active</span>
            </div>
          </Card.Header>

          <Card.Body
            className="p-3"
            style={{
              overflowY: "auto",
              height: "400px",
              border: "none",
            }}
          >
            {messages?.map((message) => (
              <Row
                key={message.id}
                className={`mb-3 ${
                  message?.type === "company"
                    ? "justify-content-end"
                    : "justify-content-start"
                }`}
              >
                <Col xs={10} md={8}>
                  <Card
                    className={
                      message.type === "company"
                        ? "text-white shadow-sm"
                        : "bg-light shadow-sm"
                    }
                    style={{
                      background:
                        message.type === "company" ? "#fff0f7" : "none",
                      border: "none",
                    }}
                  >
                    <Card.Body className="p-2">
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <Card.Title
                          className="mb-0"
                          style={{
                            color:
                              message.type === "company" ? "grey" : "black",
                            fontSize: "0.7rem",
                            fontWeight: "600",
                          }}
                        >
                          {message.type === "company" ? "You" : "Admin"}
                        </Card.Title>
                        <small
                          className="opacity-75"
                          style={{ fontSize: "12px", color: "grey" }}
                        >
                          {message?.createdAt ? (
                            <>{formatCreatedAt(message?.createdAt)}</>
                          ) : (
                            "today"
                          )}
                        </small>
                      </div>
                      <Card.Text
                        className="mb-1"
                        style={{
                          color:
                            message.type === "company" ? "#96144d" : "grey",
                        }}
                      >
                        {message.message}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            ))}
          </Card.Body>

          <Card.Footer
            className="p-2 bg-white d-flex align-items-center rounded"
            style={{ border: "none", height: "80px" }}
          >
            <InputGroup className="d-flex justify-content-center align-items-center gap-3">
              <Form.Control
                type="text"
                placeholder="Type your message..."
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                onKeyPress={(e) => e.key === "Enter" && handleSendMessage()}
                className="rounded p-2"
                style={{
                  outline: "none",
                }}
              />
              <div
                onClick={() => handleSendMessage()}
                className="rounded-circle d-flex justify-content-center align-items-center ms-2"
                style={{
                  width: "30px",
                  height: "30px",
                  background: "#96144d",
                  color: "white",
                  cursor: "pointer",
                }}
              >
                <div>
                  <FaArrowRight />
                </div>
              </div>
            </InputGroup>
          </Card.Footer>
        </Card>
      </div>
      <style jsx>{`
        .qurey-tab:hover {
          color: #ffff !important;
          background: #96144d !important;
        }
      `}</style>
    </div>
  );
};

export default ChatSupport;
